export const termsOfService = [];
